// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-comp{
  border-radius: 50%;
  background-color: #343a40;
  color:#fff;
  border: 3px solid #fff;
  z-index: 1;
    position: inherit;
}

.add-comp:focus{
  animation: rotate .5s ease
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-block/add-block.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,sBAAsB;EACtB,UAAU;IACR,iBAAiB;AACrB;;AAEA;EACE;AACF","sourcesContent":[".add-comp{\r\n  border-radius: 50%;\r\n  background-color: #343a40;\r\n  color:#fff;\r\n  border: 3px solid #fff;\r\n  z-index: 1;\r\n    position: inherit;\r\n}\r\n\r\n.add-comp:focus{\r\n  animation: rotate .5s ease\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
